import { useParams } from "react-router-dom";
import { CalculationResultPageCmp, CalculationResultPageProps } from "./types";
import {
  CALCULATION_RESULT_PAGE_TITLE
} from "ui/components/PageTitle/consts";
import { Routes } from "../../navigation";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { CalculationResultCard } from "./components/CalculationResultCard";

const CalculationResultPage: CalculationResultPageCmp = (
  props: CalculationResultPageProps
) => {
  const { calculationId } = useParams();

  const pageTitle = CALCULATION_RESULT_PAGE_TITLE;

  if(!calculationId)
    return <></>

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <PageTitle
              title={pageTitle.text}
              icon={pageTitle.icon}
              iconColor={pageTitle.iconColor}
            />
            <Breadcrumb />
          </PageHeader>
        </div>
        <CalculationResultCard calculationId={calculationId}/>
      </div>
    </>
  );
};

CalculationResultPage.route = Routes.CalculationResultPageRouter;

export default CalculationResultPage;
